import { render, staticRenderFns } from "./ProjectDescriptionEditor.vue?vue&type=template&id=1faa6e36&"
import script from "./ProjectDescriptionEditor.vue?vue&type=script&lang=ts&"
export * from "./ProjectDescriptionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports